import React, { useCallback, useMemo } from "react";
import { useObserver } from "../../../../CodesThatsGottaGoSomewhereElse";
import { Colors, Toggle } from "../../../../ui";
import { PopoutWidget } from "../../../canvas/workspace/widgets/WidgetInterface";
import { Copy, Flexer } from "../../../dashboard/elements/LayoutElements";
import { TimelineFrameAddonHeadings } from "./TimelineFrameAddon";

export const TimelineFrameAddonSettingsWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const value = useObserver(widget).value as TimelineFrameAddonHeadings;
    const opts = useMemo(() => ({
        year: value.includes('Y'),
        quarter: value.includes('Q'),
        month: value.includes('M'),
        dateline: value.includes('D'),
    }), [value]);

    const onSet = useCallback((p: Partial<typeof opts>) => {
        p = { ...opts, ...p };
        const next = [] as TimelineFrameAddonHeadings;
        if (p.year) next.push('Y');
        if (p.quarter) next.push('Q');
        if (p.month) next.push('M');
        if (p.dateline) next.push('D');
        widget.update({ value: next });
    }, [opts, value]);

    return <Flexer flex="column" gap="1" width="12" padding=".5" color={Colors.text}>
        <Flexer flex="row" align="center" justify="space-between">
            <Copy flush>Show Years</Copy>
            <Toggle size="sm" value={opts.year} onAction={x => onSet({ year: x })} />
        </Flexer>
        <Flexer flex="row" align="center" justify="space-between">
            <Copy flush>Show Quarters</Copy>
            <Toggle size="sm" value={opts.quarter} onAction={x => onSet({ quarter: x })} />
        </Flexer>
        <Flexer flex="row" align="center" justify="space-between">
            <Copy flush>Show Months</Copy>
            <Toggle size="sm" value={opts.month} onAction={x => onSet({ month: x })} />
        </Flexer>
        <Flexer flex="row" align="center" justify="space-between">
            <Copy flush>Show Dateline</Copy>
            <Toggle size="sm" value={opts.dateline} onAction={x => onSet({ dateline: x })} />
        </Flexer>
    </Flexer>;
});